import { ComponentType } from 'react';
import { BannerRegistry, BannerProps } from './bannerRegistry';

interface BannerServiceProps {
  bannerProps: BannerProps;
}

const BannerService = ({ bannerProps }: BannerServiceProps) => {
  const { template, ...props } = bannerProps;

  const Banner = BannerRegistry[template] as ComponentType<
    Omit<typeof bannerProps, 'template'>
  >;
  if (!Banner) return null;

  return <Banner {...props} />;
};

BannerService.displayName = 'BannerService';

export default BannerService;
